var map = {
	"./VIP_dark@2x.png": "gxPQ",
	"./bg_1@2x.png": "A9/c",
	"./bg_2@2x.png": "WJsD",
	"./box@2x.png": "haSR",
	"./coupon_dark@2x.png": "F5RM",
	"./coupon_light@2x.png": "yAg9",
	"./h5Bg.png": "iuIb",
	"./line @2x.png": "J8fM",
	"./pumpkin_dark@2x.png": "K2WS",
	"./pumpkin_light@2x.png": "n+Ic",
	"./title@3x.png": "gy66",
	"./tree@3x.png": "vBqa",
	"./vip_select@2x.png": "Bcqo",
	"./yuanMoney.png": "mTaJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nSLE";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary ^\.\/.*$
// module id = nSLE
// module chunks = 0